import AddIcon from '@mui/icons-material/Add';
import { Box, Stack, Typography, useMediaQuery } from '@mui/material';
import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorScreen from '../../../core-components/theme/components/ErrorScreen';
import ProtectedComponent from '../../../core-components/theme/components/ProtectedComponent';
import SearchBox from '../../../core-components/theme/components/Searchbox/Searchbox';
import Theme from '../../../core-components/theme/theme';
import Loader from '../../../globalComponents/loader/DPLoader';
import { useBatchConfigList } from '../hooks/useBatchConfigList';
import BatchConfigTable from './BatchConfigTable';
// import BatchConfigDialog from '../Dialogs/BatchConfigDialog';
import { useParams } from 'react-router-dom';
import Button from '../../../core-components/theme/components/Button/Button';

export default function BatchConfigListing() {
  const { assetId = '' } = useParams() as { assetId: string };
  const { searchString, isPending, handleSearch, handleAddBatchConfig, handleRowClick} =
    useBatchConfigList();
  const isTablet = useMediaQuery(Theme.breakpoints.down('md'));
  return (
      <Stack direction="column" spacing={3}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="title">
            Batch List
          </Typography>
          <ProtectedComponent permission="InsightTemplate_Manage_A"> 
            {/* BatchConfig_Manage_A */}
            {/* dont merge this unless this comment is removed  */}
            <Button
              onClick={handleAddBatchConfig}
              aria-label="Add a new Batch Configuration"
            >
              <Stack direction="row" alignItems="center" gap={2}>
              <AddIcon />
                {!isTablet && (
                    'CONFIGURE NEW BATCH'
                )}
              </Stack>
            </Button>
          </ProtectedComponent>
        </Stack>

        <SearchBox
          placeholder="Search Batch"
          onSearch={value => handleSearch(value)}
          onClear={() => handleSearch('')}
        />

        <Box width="100%">
          <ErrorBoundary fallback={<ErrorScreen />}>
            <Suspense fallback={<Loader height="40vh" />}>
              <BatchConfigTable isPending={isPending} searchString={searchString}  onRowClick={handleRowClick} assetId={assetId}/>
            </Suspense>
          </ErrorBoundary>
        </Box>

      </Stack>
  );
}
